<template>
    <div>
        <SalesReportTemplate
            title="Discount Report"
            :columns="columns"
            fetchRoute="/reports/discount-report"
            reportTypeCode="DISCOUNT_REPORT"
            permission="CMS_VIEW_REPORT_DISCOUNT_REPORT"
            @onResponse="handleResponse"
        >
            <template #filters>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <!-- Employee Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Employee</label>
                        <select 
                            v-model="selectedEmployee" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Employees</option>
                            <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                {{ employee.name }}
                            </option>
                        </select>
                    </div>
                    
                    <!-- Discount Type Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Discount Type</label>
                        <select 
                            v-model="selectedDiscountType" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Types</option>
                            <option value="promotion">Promotion</option>
                            <option value="manual">Manual</option>
                            <option value="employee">Employee</option>
                            <option value="loyalty">Loyalty</option>
                        </select>
                    </div>
                </div>
            </template>
        </SalesReportTemplate>
    </div>
</template>

<script>
import SalesReportTemplate from './SalesReportTemplate.vue'
import { mapState } from 'vuex'
import { http } from '@/utils/http'

export default {
    name: 'DiscountReport',
    components: {
        SalesReportTemplate
    },
    data() {
        return {
            selectedEmployee: '',
            selectedDiscountType: '',
            employees: [],
            columns: [
                { key: 'formattedDate', title: 'Date' },
                { key: 'item_code', title: 'Item Code' },
                { key: 'item_name', title: 'Item Name' },
                { key: 'qty', title: 'Quantity' },
                { key: 'rate', title: 'Original Price' },
                { key: 'amount', title: 'Final Amount' },
                { key: 'total_discount', title: 'Total Discount' },
                { key: 'discount_percentage', title: 'Discount %' },
                { key: 'discount_type', title: 'Discount Type' },
                { key: 'promotion_name', title: 'Promotion Name' },
                { key: 'applied_by_user_name', title: 'Applied By' },
            ]
        }
    },
    computed: {
        ...mapState('misc', ['warehouses'])
    },
    mounted() {
        this.loadEmployees()
    },
    methods: {
        async loadEmployees() {
            try {
                const response = await http.get('/users')
                this.employees = response.data.result || []
            } catch (error) {
                console.error('Error loading employees:', error)
            }
        },
        updateFilters() {
            // Emit filter changes to parent component
            this.$emit('filtersChanged', {
                employee_user_ids: this.selectedEmployee,
                discount_type: this.selectedDiscountType
            })
        },
        handleResponse(data) {
            // Handle response data if needed
            console.log('Discount report data:', data)
        }
    }
}
</script>

<style scoped>
/* Add any custom styles here */
</style> 